export default {"src":"/_next/static/media/red_person.41cbca38.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};